'use client';
import React from 'react';
import styled from '@benzinga/themetron';

export interface BasicAdBannerProps {
  contentAlign: 'start' | 'center' | 'end';
  buttonText: string;
  heading: string;
  subheading: string;
  textAlign: 'left' | 'center' | 'center';
  url: string;
}

export const BasicAdBanner: React.FC<BasicAdBannerProps> = ({
  buttonText,
  contentAlign,
  heading,
  subheading,
  textAlign,
  url,
}) => (
  <a
    className={`bg-gray-800 border-4 text-${textAlign} border-blue-500 text-white flex flex-col items-${contentAlign} justify-center p-2 min-h-[140px] w-full`}
    data-action={`Calendar Ad Banner Click`}
    href={url}
    rel="noreferrer"
    target="_blank"
  >
    <strong className="text-lg font-semibold leading-6 text-white">{heading}</strong>
    <p className="text-sm leading-6 text-white mb-0 font-normal">{subheading}</p>
    <StyledButton className="uppercase text-sm mt-2 py-1.5 px-4 min-w-[140px] rounded font-bold text-white bg-[#3f83f8] hover:bg-[#1c64f2] border border-[#3f83f8]">
      {buttonText}
    </StyledButton>
  </a>
);

const StyledButton = styled.button`
  transition:
    0.25s background-color ease-in-out,
    0.25s color ease-in-out,
    0.25s border-color ease-in-out;
`;
